
























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { InstanceGroupInstance } from "@/services/instances/types";
import { getInstanceGroupInstances } from "@/services/instances/instanceGroupService";
import { instanceGroupFields } from "@/components/instances/fields/instanceGroupFields";
import SelectInstancesModal from "@/components/instances/modals/SelectInstancesModal.vue";
import InstanceGroupInstanceDeleteModal from "@/components/instances/modals/InstanceGroupInstanceDeleteModal.vue";
@Component({
    components: { InstanceGroupInstanceDeleteModal, SelectInstancesModal }
})
export default class InstanceGroupInstances extends Vue {
    @Prop() groupId!: string;
    @Prop() collapseState!: boolean;
    // local state
    localGroupId = "";
    instances = [] as InstanceGroupInstance[];
    searchQuery = "";
    fields = instanceGroupFields;
    localCollapseState = true;

    // watchers
    @Watch("groupId")
    onPropertyChanged() {
        this.localGroupId = this.groupId;
        this.fetchData();
    }

    // lifecycle hooks

    // computed
    get filteredData() {
        return this.instances && this.instances
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    fetchData() {
        getInstanceGroupInstances(this.localGroupId).then(response => {
            this.instances = response;
        });
    }

    openInstancesPrompt() {
        const selectedInstances = this.instances.map(x => x.instanceId);
        (this.$refs.selectInstances as any).open(true, selectedInstances);
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
    }

    onInstanceSelected(selectedInstances: InstanceGroupInstance[]) {
        this.instances = [...this.instances, ...selectedInstances];
    }

    removeInstance(instance: InstanceGroupInstance) {
        (this.$refs.deleteInstance as any).open(instance.instanceId, instance.name);
    }

    onDeleted(id: string) {
        const item = this.instances.find(x => x.instanceId === id);
        if (!item) {
            return;
        }
        this.instances = this.instances.filter(x => x.instanceId !== id);
    }

    // events
    emitData() {
        this.$emit("instancesUpdated", this.instances.map(x => x.instanceId));
    }
}
